import { render, staticRenderFns } from "./LoginSideMenu.vue?vue&type=template&id=f449f112"
import script from "./LoginSideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginSideMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginSideMenu.vue?vue&type=style&index=0&id=f449f112&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports